import useMediaQuery from 'hooks/useMediaQuery';
import React from 'react';
import { Container, Title } from 'ui/components/styled';
import device from 'ui/theme/device';
import FilterComponent from './FilterComponent';
import RowsPerPageComponent from './RowsPerPageComponent';

const SubHeaderComponent = ({
  title,
  titleProps,
  actions,
  disposition = 'default',
  filterPlaceholder,
  filterValue,
  filterProps,
  openMobileFilter,
  onFilter,
  CloseButton,
  noFilter,
  advancedSearch,
  advancedSearchOpen,
  setAdvancedSearchOpen,
  ...rest
}) => {
  const pb = disposition === 'actions-first' ? 'm' : 'l';
  const isSmall = useMediaQuery(device.small);

  return (
    <Container flexDirection="column">
      <Container
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        gap="m"
        pb={pb}
      >
        {title && (
          <Title variant="primary" minWidth="25%" {...titleProps}>
            {title}
          </Title>
        )}
        {disposition === 'actions-first' ? (
          <>
            {actions && (
              <Container flexDirection="row" alignItems="center" width="auto" height="auto" mr="m">
                {actions}
              </Container>
            )}
            <Container
              flexDirection="row"
              alignItems="center"
              justifyContent="flex-end"
              width="50%"
              height="auto"
            >
              {!noFilter && !isSmall && (
                <FilterComponent
                  placeholder={filterPlaceholder}
                  value={filterValue}
                  onFilter={onFilter}
                  advancedSearch={advancedSearch}
                  advancedSearchOpen={advancedSearchOpen}
                  setAdvancedSearchOpen={setAdvancedSearchOpen}
                  width="100%"
                  mr="m"
                  {...filterProps}
                />
              )}
              <RowsPerPageComponent {...rest} />
            </Container>
            {CloseButton && <CloseButton />}
          </>
        ) : (
          <>
            {!noFilter && !isSmall && (
              <FilterComponent
                placeholder={filterPlaceholder}
                value={filterValue}
                onFilter={onFilter}
                {...filterProps}
              />
            )}
            <Container flexDirection="row" alignItems="center" width="auto" height="auto">
              {actions && (
                <Container
                  flexDirection="row"
                  alignItems="inherit"
                  width="auto"
                  height="auto"
                  mr="m"
                >
                  {actions}
                </Container>
              )}
              <RowsPerPageComponent {...rest} />
            </Container>
            {CloseButton && <CloseButton />}
          </>
        )}
      </Container>
      {isSmall && openMobileFilter && (
        <FilterComponent
          placeholder={filterPlaceholder}
          value={filterValue}
          onFilter={onFilter}
          width="100%"
          mb="s"
          {...filterProps}
        />
      )}
    </Container>
  );
};

export default SubHeaderComponent;
